import ProjectStatistics from './ProjectStatistics';

export default ProjectStatistics;
